import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);

let modelTimeoutId = null;

export default {
    updateEditorSaveBtnIfDataModelEdited ({ commit }, schema){
        if(schema.hasUnsavedChange()){
            commit('SET_SAVE_STATE', 'upToDate');
        }else{
            commit('SET_SAVE_STATE', 'unsaved');
        }
    },
    async createLog(context, {origin, payload, actionType}) {
        let message = '';

        // pour le moment le champs message ne peut contenir que 255 char si agrandit data les data pourrait être passé dedans
        // en attendant code commenté
        // let data;
        // if(payload.item){
        //     try{
        //         data = JSON.stringify(payload.item);
        //     }catch(e){
        //         data = 'Impossible to stringify data';
        //     }
        // }
        switch(actionType){
            case 'createItem':
                message = `New model '${payload.model}'' created on application '${context.getters.getCurrentApplication.label}' by user '${context.getters.currentUser.email}'`;
                break;
            case 'patchItem':
                message = `Model '${payload.model}' modified on application '${context.getters.getCurrentApplication.label}' by user '${context.getters.currentUser.email}'`;
                break;
            case 'changeUserPassword':
                message = `Reset password for user '${payload.email}'`;
                break;
            case 'selfResetUserPassword':
                message = `Reset password request for user '${context.getters.currentUser.email}'`;
                break;
            default:
                message = null;
        }
        if(!message) {
            return console.warn(`Error on createLog called for not specified actionType. Available actionType are ${context.getters.actionsToWatchForCreateLog}`);
        }
        return context.dispatch('createItem', {
            item: {
                message: message,
                origin: origin,
            },
            model: 'logUserActions',
            url: context.state.api.meta.listModels.logUserActions.url,
        });
    },
    validateApplicationImageUpload ({getters}, file) {
        return new Promise(async(resolve1) => {

            let width,
                height;

            let fr = new FileReader();

            function test(value) {
                return new Promise((resolve2) => {
                    fr.onload = () => {
                        let img = new Image;
                        img.onload = () => {
                            resolve2(img);
                        };
                        img.src = fr.result;
                    };
                    fr.readAsDataURL(value);
                });
            }

            let img = await test(file);

            width = img.width;
            height = img.height;

            if ( width !== 512 || height !== 512) {
                resolve1('Height and width must be equal to 512px');
                return;
            }
            resolve1(true);
            return true;
        });
    },
    afterLogout ({ commit }){
        commit('REMOVE_SCOPE', 'X-Entity-Uid');
    },
    changeCurrentLocale({commit}, data) {
        commit('SET_CURRENT_LOCALE', data);
        return;
    }
};



// WEBPACK FOOTER //
// ./src/store/actions.js